import React from 'react';

const Jeux = () => {
    return <div className="page-padding">
        Jeux page is under construction!
    </div>
}

export default Jeux